"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassElementMetadataKind = void 0;
var ClassElementMetadataKind;
(function (ClassElementMetadataKind) {
    ClassElementMetadataKind[ClassElementMetadataKind["multipleInjection"] = 0] = "multipleInjection";
    ClassElementMetadataKind[ClassElementMetadataKind["singleInjection"] = 1] = "singleInjection";
    ClassElementMetadataKind[ClassElementMetadataKind["unmanaged"] = 2] = "unmanaged";
})(ClassElementMetadataKind || (exports.ClassElementMetadataKind = ClassElementMetadataKind = {}));
//# sourceMappingURL=ClassElementMetadataKind.js.map